<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="用户名" prop="username">
    <el-input v-model="form1.username"></el-input>
  </el-form-item>
   <el-form-item label="密码" prop="password">
    <el-input type="password" v-model="form1.password"></el-input>
  </el-form-item>
   <el-form-item label="姓名" prop="linkman">
    <el-input v-model="form1.linkman"></el-input>
  </el-form-item>
   <el-form-item label="手机号" prop="mobile">
    <el-input v-model="form1.mobile"></el-input>
  </el-form-item>
  <el-form-item label="邮箱" prop="dept">
    <el-input v-model="form1.dept"></el-input>
  </el-form-item>
  <el-form-item label="用户类型">
    <template>
  <el-select v-model="form1.adminType" placeholder="请选择">
    <el-option
      v-for="item in adminTypelist"
      :key="item.code"
      :label="item.name"
      :value="item.code">
    </el-option>
  </el-select>
</template>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="checkForm('form1')"  @keyup.enter.native="checkForm('form1')">保存</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
// eslint-disable-next-line no-unused-vars
import { dataGetUrl, dataPost, getdists } from '@/api/index'
export default {
  name: 'adminmanageadd',
  data () {
    var userName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var passWord = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var Linkman = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入姓名'))
      } else {
        callback()
      }
    }
    var Mobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    var Dept = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      } else {
        // eslint-disable-next-line no-useless-escape
        const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的邮箱'))
        }
      }
    }
    return {
      form1: {
        username: '',
        password: '',
        linkman: ' ',
        state: '',
        dept: '',
        adminType: '1',
        mobile: ''
      },

      options: [{
        value: '1',
        label: '超级管理员'
      }, {
        value: '2',
        label: '机构用户'
      } ],
      adminTypelist: {},
      value: '',

      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: userName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: passWord, trigger: 'blur' }
        ],
        linkman: [
          { required: true, message: '请输入负责人姓名', trigger: 'blur' },
          { validator: Linkman, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: Mobile, trigger: 'blur' }
        ],
        dept: [
          { required: true, message: '输入负责人部门', trigger: 'blur' },
          { validator: Dept, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */
    const adminTypeCode = 'CS03000027'

    /* 后台申请默认值 */
    getdists(adminTypeCode).then(response => {
      const data = response
      that.adminTypelist = data.data.list
    })
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this

      params.append('id', this.form1.id)
      params.append('username', this.form1.username)
      params.append('password', this.form1.password)
      params.append('linkman', this.form1.linkman)
      params.append('mobile', this.form1.mobile)
      params.append('dept', this.form1.dept)
      params.append('adminType', this.form1.adminType)
      // eslint-disable-next-line eqeqeq,no-lone-blocks
      if (that.form1.username == '') { alert('请输入用户账号') } else if (that.form1.password == '') { alert('请输入用户密码') } else if (that.form1.linkman == '') { alert('请输入联系人') } else if (that.form1.mobile == '') { alert('请输入联系电话') } else if (that.form1.dept == '') { alert('请输入负责人部门') }
      // eslint-disable-next-line no-lone-blocks
      { dataPost(rootPathssb.rootPath + '/admini/add', params).then(function (response) {
        that.checkSignin(response.data.result)
        // eslint-disable-next-line eqeqeq
        if (response.data.result == 1) {
          alert('保存成功')
          that.$router.push({path: '/adminmanage'})
          console.log('cg')
        };

        console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222); alert('失败')
      }) }
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }

}
</script>

<style >
.body1{
  width:600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/adminmanageadd.vue